import { Emitter, EventType } from "mitt";
import { InjectionKey } from "vue";

export const eventBusKey: InjectionKey<Emitter<Record<EventType, unknown>>> = Symbol('eventBus');

export const purchaseEventKey = Symbol();